// extracted by mini-css-extract-plugin
module.exports = {"authForm":"LoginForms_authForm__3Hg7q","signInButton":"LoginForms_signInButton__24EnR","title":"LoginForms_title__1WIqY"};